import { IExternalTag } from "contexts/language";
import { apiGet, FetchResponse } from "fetchApi";

export const fetchDynamicTags = async (
    params?: Record<string, unknown>
): Promise<FetchResponse<IExternalTag[]>> => {
    return apiGet<IExternalTag[]>("/configurations/tags/", { params });
};